var map = {
	"./News_item_1.jpg": "005f",
	"./News_item_10.jpg": "09fe",
	"./News_item_11.jpg": "eed2",
	"./News_item_12.jpg": "9c55",
	"./News_item_13.jpg": "f225",
	"./News_item_14.jpg": "23e3",
	"./News_item_15.jpg": "e8bd",
	"./News_item_16.jpg": "45a8",
	"./News_item_2.jpg": "9d71",
	"./News_item_3.jpg": "83f2",
	"./News_item_4.jpg": "6f20",
	"./News_item_5.jpg": "9722",
	"./News_item_6.jpg": "cf43",
	"./News_item_7.jpg": "a3b6",
	"./News_item_8.jpg": "a01d",
	"./News_item_9.jpg": "879d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "791c";